import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Styles from '../styles/Forms.module.css'
import { registerMenu, registerUser } from '../utils/database'
import { useState } from 'react'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import LogoutIcon from '@mui/icons-material/Logout';
import { logOut } from '../utils/firebase';
import { storeIDIsAvailable } from '../utils/database';
import EasySnackBar from './EasySnackBar';
import FormSide from '../images/form_side.webp'

export default function StoreCreator(props) {
    const [storeID, setStoreID] = useState('')
    const [errorMessage, setErrorMessage] = useState('')

    const navigate = useNavigate()

    const initializeUser = async () => {

        if (storeID.length === 0) {
            setErrorMessage('El identificador debe tener al menos 1 caracter')

        } else {
            if (await storeIDIsAvailable(storeID)) {
                registerUser(props.userAuth, storeID)
                registerMenu(props.userAuth, storeID)
                props.updateUserData()

            } else {
                setErrorMessage('El identificador elegido no está disponble')
            }
        }
    }

    const closeSession = () => {
        logOut()
        navigate('/')
    }


    return (
        <>
            <div className={Styles.container}>
                <Stack
                    direction='row'
                    flexWrap='wrap'
                    justifyContent='center'
                    className={Styles.content}
                >
                    <Stack spacing={3} className={Styles.form}>

                        <Stack direction='row' justifyContent='space-between'>
                            <Typography variant='h4'>
                                Bienvenido a Tookeat!
                            </Typography>

                            <IconButton onClick={closeSession.bind(this)} color='error'>
                                <LogoutIcon />
                            </IconButton>
                        </Stack>

                        <Divider />

                        <Stepper>
                            <Step completed>
                                <StepLabel>Verificar</StepLabel>
                            </Step>
                            <Step active>
                                <StepLabel>Elegir ID</StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>Listo!</StepLabel>
                            </Step>
                        </Stepper>

                        <Typography variant='body1'>
                            Antes de empezar tienes que definir el identificador de tu tienda.
                            <br />
                            Igual no te preocupes, lo puedes cambiar mas tarde!
                        </Typography>

                        <TextField
                            label="Identificador"
                            variant="outlined"
                            required
                            helperText='Maximo 40 caracteres'
                            value={storeID}
                            onChange={e => {
                                const regex = /^[a-zA-Z0-9]*$/;
                                const input = e.target.value.toLocaleLowerCase()
                                if (regex.test(input) && input.length < 40) {
                                    setStoreID(input)
                                }
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    initializeUser()
                                }
                            }}
                        />

                        <Divider >
                            <Typography variant='h6'>
                                El link a tu comercio será
                            </Typography>
                        </Divider>

                        <Stack direction='row' justifyContent='center' alignItems='center' flexWrap='wrap'>
                            <Typography color='text.secondary' variant='h5'>
                                tookeat.com/
                            </Typography>
                            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                            <Typography variant='h6' sx={{ wordBreak: 'break-all' }}>
                                {storeID}
                            </Typography>
                        </Stack>

                        <Divider />

                        <Button variant="contained" onClick={() => initializeUser()}>
                            Guardar cambios
                        </Button>

                    </Stack>
                    <div className={Styles.sideImage} style={{ backgroundImage: 'url(' + FormSide + ')' }}></div>

                </Stack>
            </div>

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />
        </>
    )

}